/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioMicAIcon20Solid = forwardRef('MediaAudioMicAIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 1a3.75 3.75 0 0 0-3.75 3.75V10a3.75 3.75 0 1 0 7.5 0V4.75A3.75 3.75 0 0 0 10 1Z" }),
        React.createElement("path", { d: "M4 8a1 1 0 0 1 1 1v1a5 5 0 0 0 10 0V9a1 1 0 1 1 2 0v1a7.001 7.001 0 0 1-6 6.93V18h2.5a1 1 0 1 1 0 2h-7a1 1 0 1 1 0-2H9v-1.07A7.001 7.001 0 0 1 3 10V9a1 1 0 0 1 1-1Z" })));
});
